import React from 'react';
import { Box } from '@mui/material';
import { TabPanelProps } from './types';

export const CustomTabPanel = React.memo(({ children, value, index, ...other }: TabPanelProps) => {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ width: '100%' }}>{children}</Box>}
        </div>
    );
});

CustomTabPanel.displayName = 'CustomTabPanel';
